import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useLeagueColumns } from "@/pages/leagues/hooks/use-columns";
import { ILeagueData } from "@/types/league";

export const LeaguesList = () => {
  const columns = useLeagueColumns();

  const table = useTable<ILeagueData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      // Leagues have no sortable string field, so no initial sorter.
      meta: { defaultQueryBy: "name" },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="leagues" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
